import { Controller, ControllerProps, FieldError } from "react-hook-form";
import ReactSelect from "../react-select";
import { DropdownOption } from "../dropdown";
import { GroupBase, StylesConfig } from "react-select";

interface Props extends Omit<ControllerProps, "render"> {
  name: string;
  control: any;
  label?: string;
  placeholder?: string;
  options: DropdownOption[];
  isMulti?: boolean;
  isSearchable?: boolean;
  isClearable?: boolean;
  isDisabled?: boolean;
  className?: string;
  labelClassName?: string;
  containerClassName?: string;
  error?: FieldError;
  styles?: StylesConfig<DropdownOption, boolean, GroupBase<DropdownOption>> | undefined;
  onChange?: any;
  value?: number;
}

const Select: React.FC<Props> = (props) => {
  const {
    placeholder = "انتخاب کنید...",
    className,
    options,
    error,
    control,
    name,
    label,
    isMulti = false,
    isSearchable = false,
    isClearable = false,
    isDisabled = false,
    labelClassName,
    containerClassName,
    styles,
    onChange,
    value,
    ...rest
  } = props;
  return (
    <div className={className}>
      <label className={containerClassName ? containerClassName : ""}>
        <div className={labelClassName ? labelClassName : ""}>{label}</div>

        <Controller
          name={name}
          control={control}
          render={({ field }) => {
            return (
              <ReactSelect
                isMulti={isMulti}
                isClearable={isClearable}
                isSearchable={isSearchable}
                isDisabled={isDisabled}
                placeholder={placeholder}
                options={options}
                onChange={onChange ? onChange : field.onChange}
                value={value ? value : field.value}
                styles={styles}
              />
            );
          }}
          {...rest}
        />
      </label>
      {error && <div className="text-pkc-red">{error.message}</div>}
    </div>
  );
};

export default Select;
